import mailSyncFolderMapping from '../../../../../../vendor/inbox/mailsync-form/src/Resources/js/mail-sync-folder-mapping';

const initialize = () => {
    mailSyncFolderMapping();
};
export default initialize;
